/* New Build JS */

$( document ).ready(function() {
    
    console.log("Ready ");

    // Annountments section 
    const Announcements = {
        slides: parseInt($('[data-slider]','.section--announcements').attr('data-slides')),
        autoplay: Boolean($('[data-slider]','.section--announcements').attr('data-autoplay')) || false
    }
    if (Announcements.slides > 1 ) {
        $('[data-slider]','.section--announcements').slick({
            dots: false,
            arrows: false,
            autoplay: Announcements.autoplay,
            autoplaySpeed: 3500
        });
    }
    

    // Image with text | Slider

    $('[data-slider="true"]','.section--image-with-text').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        lazyLoad: 'progressive'
    });


});
